<template>
  <div class="max-w-screen-2xl mx-auto px-3 sm:px-4 lg:px-6 py-3 sm:py-6">
    <!-- Header -->
    <div class="mb-4 sm:mb-6">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">
        {{ t('app.subscription.settings.title') }}
      </h1>
      <p class="mt-1 text-xs sm:text-sm text-gray-600 dark:text-gray-400">
        {{ t('app.subscription.settings.subtitle') }}
      </p>
    </div>

    <!-- Loading State -->
    <LoadingSpinner
      v-if="isLoading"
      size="xl"
      color="primary"
      :show-text="false"
    />

    <!-- Content -->
    <div
      v-else
      class="grid grid-cols-1 lg:grid-cols-2 gap-6"
    >
      <GeneralSettingsSection :restaurant-settings="restaurantSettings" />
      <PaymentSettingsSection :restaurant-settings="restaurantSettings" />
      <PrintSettingsSection v-if="false" :restaurant-settings="restaurantSettings" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRestaurantSettings } from '@/composables/useRestaurantSettings'
import PrintSettingsSection from '@/components/configuration/PrintSettingsSection.vue'
import GeneralSettingsSection from '@/components/configuration/GeneralSettingsSection.vue'
import PaymentSettingsSection from '@/components/configuration/PaymentSettingsSection.vue'
import LoadingSpinner from '@/components/base/LoadingSpinner.vue'

const { t } = useI18n()

// Restaurant settings management
const restaurantSettings = useRestaurantSettings()

const isLoading = computed(() => restaurantSettings.loadingSettings.value)

// Lifecycle
onMounted(() => {
  restaurantSettings.loadSettings()
})
</script>
